module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      H. Jackson Brown\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v(" A New York Times best-selling author, H. Jackson Brown’s publications are universal in appeal, with more than 30 million copies in print, available in 35 languages. His 33 books inspire readers throughout the world. He lives in Nashville, Tennessee.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/hY6KDp/tc-custom/9781418573652.jpg?1726617345278",
      "alt": "This image is the cover for the book Life's Little Instruction Book"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Life's Little Instruction Book\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("The #1 "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestseller—now in a fresh new format, offering a new generation simple yet powerful wisdom.")])]), _c('p', [_vm._v("The"), _c('i'), _vm._v("Life’s Little Instruction Book series has sold more than ten million copies, spent more than two years atop the "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestseller list, and has been translated into 33 languages. Originally written from a father to a son, the book offers insights, simple suggestions, heartfelt humor, and reminders for readers of all ages. This edition offers a new trim size and on-trend design for a new generation.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0